module.exports = __webpack_public_path__ + "img/hospitium-16.5bd29e7e.jpg";